import React from 'react';
import styles from './Summary.module.scss';
import { useSelector } from 'react-redux';
import { roundNumber } from '../../../utils/formatDecimal';
import { BET_SLIP_TABS } from '../../../constants/defaultValues';
import betSlipCalculator from '../../../utils/betSlipCalculator';
import { formatMessage, getTranslation } from '../../../utils/translation';

const Summary = props => {
    const activeTab = useSelector(state => state.betSlip.activeTab);
    const betLines = useSelector(state => state.betSlip.betLines);
    const stakes = useSelector(state => state.betSlip.stakes);
    const selectedCombinations = useSelector(state => state.betSlip.selectedCombinations);

    const {
        totalOdds,
        totalStake,
        toWin,
        expectedBetsCount,
    } = betSlipCalculator.calculateTicketDetails({
        betLines,
        activeTab,
        stakes,
        selectedCombinations,
    });

    return (
        <div className={styles.summary}>
            <table className={styles.summaryTable}>
                <tbody>
                    {activeTab === BET_SLIP_TABS.system.id && selectedCombinations.length > 0 ? (
                        <tr>
                            <th align='left'>{getTranslation('betSlip.summary.system')}</th>
                            <td align='right'>{selectedCombinations.join(', ')}</td>
                        </tr>
                    ) : null}
                    {expectedBetsCount > 0 ? (
                        <tr>
                            <th align='left'>{getTranslation('betSlip.summary.numberOfBets')}</th>
                            <td align='right'>
                                {expectedBetsCount === 1
                                    ? formatMessage(getTranslation('betSlipPlacedTicketBetCount'), {
                                          count: expectedBetsCount,
                                      })
                                    : formatMessage(
                                          getTranslation('betSlipPlacedTicketBetsCount'),
                                          {
                                              count: expectedBetsCount,
                                          }
                                      )}
                            </td>
                        </tr>
                    ) : null}
                    {totalOdds > 0 ? (
                        <tr>
                            <th align='left'>{getTranslation('betSlip.summary.totalOdds')}</th>
                            <td align='right'>{roundNumber(totalOdds, 2)}</td>
                        </tr>
                    ) : null}

                    <tr>
                        <th align='left'>{getTranslation('betSlip.summary.totalStake')}</th>
                        <td align='right' className={styles.total}>
                            {roundNumber(totalStake, 2)} AZN
                        </td>
                    </tr>
                    <tr>
                        <th align='left'>{getTranslation('betSlip.summary.toWin')}</th>
                        <td align='right' className={styles.total}>
                            {roundNumber(toWin, 2)} AZN
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Summary;
